import styled from 'vue-styled-components';

import { BLUE, GRAY, square } from '@/styles/common.styled';
import {
    FLEX_COLUMN_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@/styles/common.styled.component';

export const CardWrapper = styled(FLEX_COLUMN_DIV)`
    flex: 1;
    gap: 8px;
    padding: 12px 0;
`;

export const GoalCard = styled(FLEX_COLUMN_DIV)`
    flex: 1;
    padding: 0 0 0 3px;

    & .adriel-field-input {
        width: 100% !important;

        /* Chrome, Safari, Edge, Opera */
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */
        &[type='number'] {
            -moz-appearance: textfield;
        }
    }
`;

export const CardHeader = styled(FLEX_VERTICAL_CENTER_DIV)`
    flex: 1;
    flex-direction: space-between;
    gap: 8px;

    & .adriel-field-wrapper {
        width: 240px;

        input {
            height: 34px;
        }
    }
`;

export const MetricLabel = styled.div`
    flex: 1;

    font-size: 14px;
    font-weight: 600;

    max-width: 200px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const IconWrapper = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 8px;
    cursor: pointer;

    border: 1px solid ${GRAY(30)};
    border-radius: 2px;

    &:hover {
        background: #0000000d;
    }
`;

export const CardContent = styled.div`
    flex: 1;
    display: flex;

    & span {
        flex: 6;
    }
`;

export const GoalValueWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    width: 240px;
    height: 34px;
    border-radius: 3px;
    border: 1px solid ${GRAY(30)};
`;

export const ItemBox = styled(FLEX_VERTICAL_CENTER_DIV, {
    dragCursor: String,
    width: String,
})`
    overflow: hidden;

    background-color: ${BLUE(10)};
    padding: 3px 10px;
    font-size: 12px;
    border-radius: 12px;
    margin: 0 4px 0 4px;
    width: ${({ width = 'auto' }) => width};

    .text-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    & .item-text {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;

        height: auto;
        font-size: 14px;
        text-align: left;
        word-break: break-word;
        margin: 0 4px;
        color: ${BLUE(60)};
    }

    & svg {
        ${square(12)};
        min-width: 12px;
    }

    & .close,
    & .share-icon {
        fill: ${BLUE(60)};
        cursor: pointer;
    }
`;

export const SwitchWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    width: 282px;
    margin-left: auto;
    gap: 2px;

    .gear-icon {
        cursor: pointer;
    }
`;

export const SwitchLabel = styled.div`
    margin-left: 6px;

    font-size: 12px;
    font-weight: 500;
    color: ${GRAY(90)};
`;
